<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 17 14`"
    :width="getWidth"
  >
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
      <g id="Mobile-Home" transform="translate(-30.000000, -142.000000)" stroke="#999999" stroke-width="1.33333333">
        <g id="sliders-(2)" transform="translate(31.000000, 143.000000)">
          <line x1="2" y1="12" x2="2" y2="7.33333333" id="Path"></line>
          <line x1="2" y1="4.66666667" x2="2" y2="0" id="Path"></line>
          <line x1="7.33333333" y1="12" x2="7.33333333" y2="6" id="Path"></line>
          <line x1="7.33333333" y1="3.33333333" x2="7.33333333" y2="0" id="Path"></line>
          <line x1="12.6666667" y1="12" x2="12.6666667" y2="8.66666667" id="Path"></line>
          <line x1="12.6666667" y1="6" x2="12.6666667" y2="0" id="Path"></line>
          <line x1="0" y1="7.33333333" x2="4" y2="7.33333333" id="Path"></line>
          <line x1="5.33333333" y1="3.33333333" x2="9.33333333" y2="3.33333333" id="Path"></line>
          <line x1="10.6666667" y1="8.66666667" x2="14.6666667" y2="8.66666667" id="Path"></line>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-filter'

  export default {
    name: 'SvgIconFilter',
    mixins: [ bem ],
    props: {
      height: {
        default: '14',
        type: String
      },
      width: {
        default: '17',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.setNamespace(namespace)
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconFilter.vue